import React from 'react';
import { BLOCKS } from '@contentful/rich-text-types';
import { ILargeTestimonialFields } from '../../../types/contentful';
import { ScrollReveal } from '../ScrollReveal';

interface Props extends ILargeTestimonialFields {
  sysId?: string;
}

export function LargeTestimonial({
  name,
  blockquote,
  leftGradientColor,
  rightGradientColor,
  additionalDetail,
  sysId
}: Props) {
  const renderRichText = (content: any[]) => {
    return content.map((node, index) => {
      if (node.nodeType === 'text') {
        const isBold = node.marks.some(
          (mark: { type: string }) => mark.type === 'bold'
        );
        return (
          <span
            key={index}
            className={isBold ? 'font-medium text-gradient' : 'font-medium'}
            style={
              isBold
                ? {
                    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                    // @ts-ignore
                    '--tw-gradient-stops': `${leftGradientColor}, ${rightGradientColor}`
                  }
                : {}
            }
          >
            {node.value}
          </span>
        );
      }

      // Check if node is a paragraph and reursively process its children
      if (node.nodeType === BLOCKS.PARAGRAPH) {
        return (
          <p
            key={index}
            className="text-[28px] leading-[115%] desktop:text-[3.2rem]"
          >
            {renderRichText(node.content)}
          </p>
        );
      }

      return null;
    });
  };

  return (
    <ScrollReveal>
      <div
        className="block-container"
        data-testid="largeTestimonial"
        id={sysId}
      >
        <div className="flex flex-col items-center justify-center rounded-[24px] bg-white py-12 text-center tiny:min-w-[250px] tablet:max-w-[640px] desktop:w-[850px] desktop:py-16">
          <div className="flex text-balance pb-6">
            {renderRichText(blockquote.content)}
          </div>
          <div className="block tablet:flex tablet:items-center">
            <p className="black mb-2 mr-0 text-center text-[16px] font-medium leading-none tablet:mb-0 tablet:mr-2 desktop:text-[20px]">
              {name}
            </p>
            <p className="black mr-2 hidden text-center text-[16px] leading-none tablet:block desktop:text-[20px]">
              •
            </p>
            <p className="text-center font-glRepro text-[16px] leading-none text-black desktop:text-[20px]">
              {additionalDetail}
            </p>
          </div>
        </div>
      </div>
    </ScrollReveal>
  );
}
